import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Footer() {
  const { ref: bottomRef, isVisible: bottomVisible } = useScrollReveal();

  return (
    <footer className="relative bg-background-950 border-t border-white/5">
      {/* Top gradient transition */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-500/30 to-transparent" />

      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div ref={bottomRef} className={`pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 reveal ${bottomVisible ? 'visible' : ''}`}>
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} AInnovation Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}